const getters = {
  sid: state => state.app.sid,
  terminal: state => state.app.terminal,
  orderInfo: state => state.app.orderInfo,
  orderList: state => state.app.orderList,
  popShow: state => state.app.popShow,
  popShow1: state => state.app.popShow1,
  distance: state => state.app.distance
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getter.js